import Constant from '@/common/constant/Constant';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import Utils from '@/common/utils/utils';
import { onReadNotification, onScrollPanelNotify } from '@/component/notification/handler/NotificationHandler';
import { getTicketDetailAPI } from '@/service/ticketService';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { currentPageNoticationListAtom, notificationListAtom, notificationUnReadListAtom } from '@/state/atom/notificationAtom';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import {
    projectInuseDetailAtom,
    projectListInCorporationByUserIdAtom
} from '@/state/atom/projectAtom';
import { userAtom } from '@/state/atom/userAtom';
import { setPanelSelector } from '@/state/selector/panelSelector';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import { I18n } from 'aws-amplify';
import moment from 'moment';
import { useState } from 'react';
import { useHistory } from 'react-router';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { hasKnowledgeChatPermissionInChatThread } from '@/component/ticketKnowledge/handler/ListTicketKnowledgeHandler';
import LoadingIndicator from '@/component/common/LoadingIndicator';
import './NotificationList.css';
import { getProjectById } from '@/service/projectService';

export default function NotificationList(props) {
    const history = useHistory();

    const addNewPanel = useSetRecoilState(setPanelSelector);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);

    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);
    // common userDetail state
    const [userDetail, setUserDetail] = useRecoilState(userAtom);

    // common notificationList state
    const [notificationList, setNotificationList] = useRecoilState(notificationListAtom);

    // common notificationList unread
    const [notificationUnReadList, setNotificationUnReadList] = useRecoilState(
        notificationUnReadListAtom
    );
    const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    // common projectInuse state
    const [projectDetail, setProjectDetail] = useRecoilState(projectInuseDetailAtom);
    const [isDataChange, setIsDataChange] = useState({
        status: false,
        msg: ''
    });
    const [showPopupAdminModeOff, setShowPopupAdminModeOff] = useState(false);

    const [currentPage, setCurrentPage] = useRecoilState(currentPageNoticationListAtom);
    
    // const projectList = useRecoilValue(projectListInCorporationAtom);
    const projectList = useRecoilValue(projectListInCorporationByUserIdAtom);

    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);

    const handleOpenKnowledgeChatThreadPanel = async sourceInfo => {
        try {
            let isHasPermission = false
            if (sourceInfo.projectFocus !== 'any') {
                setIsLoading(true)
                const [ticketDetailResult, projectFocusDetail] = await Promise.all([
                    getTicketDetailAPI(props?.API, sourceInfo?.ticketId),
                    getProjectById(props?.API, sourceInfo.projectFocus)
                ]);
                setIsLoading(false)
                isHasPermission = hasKnowledgeChatPermissionInChatThread(
                    ticketDetailResult?.detailTicket,
                    projectFocusDetail,
                    userDetail?.id
                );
                sourceInfo.deletedAt = ticketDetailResult.detailTicket.deletedAt
                if (!isHasPermission) {
                    setIsShowConfirmModal(true);
                    return;
                }
            }else{
                let ticketKnowledgeResult = await getTicketDetailAPI(
                    props?.API,
                    sourceInfo?.ticketId
                );

                const detailKnowledgeTicket = ticketKnowledgeResult.detailTicket;
                let permissionObject = Utils.getChatPermissionOfTicket(detailKnowledgeTicket);
                let permission = permissionObject.permission
                if (permissionObject.isByViewPermission) {
                    if (sourceInfo.orgFocus === detailKnowledgeTicket.affiliationOrganization) {
                        isHasPermission =
                           (permission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG) ||
                            permission.includes(Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC));
                    } else {
                        isHasPermission = permission.includes(
                            Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC
                        );
                    }
                } else {
                    if (sourceInfo.orgFocus === detailKnowledgeTicket.affiliationOrganization) {
                        isHasPermission = [
                            Constant.KNOWLEDGE_CHAT_PERMISSION.PUBLIC,
                            Constant.KNOWLEDGE_CHAT_PERMISSION.IN_ORG
                        ].includes(permission);
                    } else {
                        isHasPermission = permission === Constant.KNOWLEDGE_CHAT_PERMISSION.PUBLIC;
                    }
                }
                sourceInfo.deletedAt = detailKnowledgeTicket.deletedAt
            }

            if (!isHasPermission) {
                setIsShowConfirmModal(true);
                return;
            }

            let ticketDetail = {
                id: sourceInfo?.ticketId,
                outline: JSON.stringify({ jp: sourceInfo?.ticketTitle }),
                deletedAt: sourceInfo.deletedAt,
            };
            addNewPanel({
                type: Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD,
                tabId: ticketDetail.id,
                props: argsAll.props,
                ticketId: ticketDetail.id,
                ticketOutline: ticketDetail.outline,
                isTicketDeleted: !Utils.isEmptyString(ticketDetail?.deletedAt) ? true : false,
            });
        } catch (error) {
            console.log('sourceInfo :>> ', error);
            setIsLoading(false);
        }
    };

    const argsAll = {
        props: props,
        addNewPanel: addNewPanel,
        panelList,
        setPanelList,
        API: props?.API,
        corporationDetail: corporationDetail,
        userDetail: userDetail,
        setUserDetail,
        projectDetail: projectDetail,
        setProjectDetail,
        notificationList: notificationList,
        setNotificationList: setNotificationList,
        notificationUnReadList,
        setNotificationUnReadList,
        history,
        //setTicketListType,
        projectList,
        isProjectManager,
        isShowConfirmModal,
        setIsShowConfirmModal,
        handleOpenKnowledgeChatThreadPanel: handleOpenKnowledgeChatThreadPanel,
        projectInuseDetail: projectDetail,
        setIsDataChange,
        setShowPopupAdminModeOff
    };

    const isReadNotification = notify => {
        return notify?.footPrint?.includes(userDetail?.id);
    };

    return (
        <div className="mainNotify">
            <LoadingIndicator isLoading={isLoading} />
            <ul
                className="notify-list"
                id="notify-list-unix"
                onScroll={e =>
                    onScrollPanelNotify(
                        e,
                        setIsLoading,
                        setNotificationList,
                        props?.API,
                        setCurrentPage,
                        currentPage,
                        projectList
                    )
                }
            >
                {!Utils.isEmptyArray(notificationList) &&
                    notificationList.map(notify => {
                        let notifyData = { ...notify };
                        if (notifyData?.objectType === Constant.NOTIFICATION_OBJECT_TYPE.EMAIL) {
                            notifyData = {
                                ...notifyData,
                                notificationMsg: Utils.escapeHtmlCharacters(
                                    notifyData?.notificationMsg
                                )
                            };
                        } else {
                            notifyData = {
                                ...notifyData,
                                notificationMsg: notifyData?.notificationMsg
                            };
                        }
                       
                        return (
                            <li
                                key={notifyData.id}
                                onClick={() => onReadNotification(argsAll, notifyData)}
                                className={
                                    isReadNotification(notifyData)
                                        ? 'notify-item read'
                                        : 'notify-item unread'
                                }
                            >
                                <div
                                    className="notify-content"
                                    dangerouslySetInnerHTML={{
                                        __html: notifyData?.notificationMsg
                                    }}
                                >
                                    {/* {notify.notificationMsg} */}
                                </div>
                                <div className="notify-time">
                                    {moment(new Date(notifyData.createdAt)).format('YYYY/MM/DD HH:mm')}
                                </div>
                            </li>
                        ) 
                    })}
            </ul>
            <ConfirmDialog
                isOpen={isShowConfirmModal}
                textSubmit={I18n.get('COMBTN004')}
                msgConfirm={I18n.get('COMMSG001')}
                okCallBack={() => setIsShowConfirmModal(false)}
            />
            <ConfirmDialog
                isOpen={showPopupAdminModeOff}
                textSubmit={I18n.get('COMBTN002')}
                msgConfirm={I18n.get('MSG-CM-PLEASE-ON-ADMIN-MODE')}
                okCallBack={() => setShowPopupAdminModeOff(false)}
            />

            {/* Modal confirm error data */}
            <ConfirmDialog
                isOpen={isDataChange.status}
                msgConfirm={isDataChange.msg}
                okCallBack={() =>
                    setIsDataChange({
                        status: false,
                        msg: ''
                    })
                }
            />
        </div>
    );
}
